<template>
  <FormModal v-if="showPopup" :closePopup="closePopup" />
  <div>
    <Navbar :openPopup="openPopup"/>
    <!-- <PageTitle pageTitle="Blog Details" /> -->
    <Details  :openPopup="openPopup"/>
    <FooterStyleFour />
  </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageTitle from '../Common/PageTitle'
import Details from '../ResourceDetail/Details.vue'
import FooterStyleFour from '../Layout/FooterStyleFour'
import FormModal from "../HomeThree/FormModal.vue";

export default {
  name: 'ResourceDetails',
  components: {
    Navbar,
    PageTitle,
    Details,
    FooterStyleFour,
    FormModal
  },
  data() {
    return {
      showPopup: false
    }
  },
  methods: {
    openPopup() {
      this.showPopup = true;
    },
    closePopup() {
      this.showPopup = false;
    }
  }
}
</script>